import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", {
  for: "segmentMame",
  class: "small-label"
}, "Наименование кабинета", -1)
const _hoisted_3 = { class: "flex flex-col m-t-8" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", {
  for: "login",
  class: "small-label"
}, "Логин", -1)
const _hoisted_5 = { class: "flex flex-col m-t-8" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  for: "external_id",
  class: "small-label"
}, "Внешний id", -1)
const _hoisted_7 = { class: "flex flex-col m-t-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: "small-label"
}, "Площадка", -1)
const _hoisted_9 = { class: "flex flex-col m-t-8" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Имена кампаний проверяются в SSP", -1)
const _hoisted_11 = { class: "fl m-b-8 m-t-4" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  for: "yes",
  class: "p-l-4"
}, "Да", -1)
const _hoisted_13 = { class: "fl" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  for: "no",
  class: "p-l-4"
}, "Нет", -1)
const _hoisted_15 = { class: "flex flex-col m-t-8" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "small-label" }, "Использовать в UI", -1)
const _hoisted_17 = { class: "fl m-b-8 m-t-4" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  for: "use_in_ui_yes",
  class: "p-l-4"
}, "Да", -1)
const _hoisted_19 = { class: "fl" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", {
  for: "use_in_ui_no",
  class: "p-l-4"
}, "Нет", -1)
const _hoisted_21 = { class: "flex m-t-18 m-b-8 fl-jc-sb" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("label", { for: "updated" }, "Статистика собирается в SSP", -1)

import InputText from "primevue/inputtext";
import InputSwitch from "primevue/inputswitch";
import CatalogDataBaseInput from "@/widgets/forms/CatalogDataBaseInput.vue";
import ListFilterForm from "@/widgets/forms/ListFilterForm.vue";
import RadioButton from "primevue/radiobutton";


export default /*#__PURE__*/_defineComponent({
  __name: 'AdsCabinetFilterForm',
  props: {
    isFilterEnabled: { type: Boolean }
  },
  emits: ["toggleFilter", "setFilter"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;

const initialFilter = {
  name: "",
  login: "",
  external_id: "",
  source_slug: [] as string[],
  is_statistics_required: true,
  is_naming_checked: "",
  use_in_ui: "",
};

const setParentFilter = (filter: any, isSetted: boolean) => {
  emits("setFilter", filter, isSetted);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListFilterForm, {
    "is-filter-enabled": props.isFilterEnabled,
    "initial-filter": initialFilter,
    onToggleFilter: _cache[0] || (_cache[0] = ($event: any) => (emits('toggleFilter'))),
    onSetFilter: setParentFilter
  }, {
    fields: _withCtx((slotProps) => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createVNode(_unref(InputText), {
          id: "segmentMame",
          placeholder: "Введите название",
          modelValue: slotProps.filter.name,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.name) = $event),
          "aria-describedby": "username-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_unref(InputText), {
          id: "login",
          placeholder: "Введите логин",
          modelValue: slotProps.filter.login,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.login) = $event),
          "aria-describedby": "login-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_unref(InputText), {
          id: "external_id",
          placeholder: "Введите внешний id",
          modelValue: slotProps.filter.external_id,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.external_id) = $event),
          "aria-describedby": "external_id-help"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode(CatalogDataBaseInput, {
          "not-search": true,
          useIdOnly: true,
          selectType: "source",
          isSegmentSetted: false,
          modelValue: slotProps.filter.source_slug,
          "onUpdate:modelValue": 
            ($event) => (slotProps.filter.source_slug = $event)
          
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.is_naming_checked,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.is_naming_checked) = $event),
            inputId: "yes",
            name: "active",
            value: "1"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_12
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.is_naming_checked,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.is_naming_checked) = $event),
            inputId: "no",
            name: "active",
            value: "0"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_14
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.use_in_ui,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.use_in_ui) = $event),
            inputId: "use_in_ui_yes",
            name: "use_in_ui",
            value: "1"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_18
        ]),
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_unref(RadioButton), {
            modelValue: slotProps.filter.use_in_ui,
            "onUpdate:modelValue": ($event: any) => ((slotProps.filter.use_in_ui) = $event),
            inputId: "use_in_ui_no",
            name: "use_in_ui",
            value: "0"
          }, null, 8, ["modelValue", "onUpdate:modelValue"]),
          _hoisted_20
        ])
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createVNode(_unref(InputSwitch), {
          modelValue: slotProps.filter.is_statistics_required,
          "onUpdate:modelValue": ($event: any) => ((slotProps.filter.is_statistics_required) = $event),
          inputId: "updated"
        }, null, 8, ["modelValue", "onUpdate:modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["is-filter-enabled"]))
}
}

})